import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { ModalService } from '../../../core/services/modal.service';

@Component({
  selector: 'tt-choice',
  templateUrl: './choice.component.html',
  styleUrls: ['./choice.component.css']
})
export class ChoiceComponent implements OnInit {
    choiceKeyno;

    public edit?: Edit;

    public saving = false;

    public productNameChoiceButtons: FormButton[] = [
        { id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'product', gotoParms: () => this.edit!.prod_keyno_choice ?? '' }
    ];

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.choiceKeyno = this.stateService.getStateParams()['choice_keyno'];
    }

    private async loadEdit() {
        if (!!this.choiceKeyno) {
            this.edit = (await this.datatask.Post(1214, { choice_keyno: this.choiceKeyno }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(1819, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    choice_keyno: string;
    choice_belong_to_prod_id: string;
    choice_belong_to_prod_name: string;
    stdchoice_prod_id: string;
    lock_possibilities: string;
    prod_id_choice: string;
    prod_name_choice: string;
    page_heading: string;
    prod_id: string;
    nbr_of_choicepossibilities: string;
    prod_keyno_choice: string;
    restrictpossibility: string;
}
